import { PanelAddReseller } from "../../../UI/Resellers/Add/PanelAddReseller";

const AddReseller = () => {
  return (
    <div>
      <PanelAddReseller />
    </div>
  );
};

export default AddReseller;
